import cn from "classnames"
import { FC, HTMLAttributes, memo, PropsWithChildren } from "react"
import "./index.scss"
import "./index.scss"

interface OutlinedTextProps extends HTMLAttributes<HTMLParagraphElement> {
  text?: number | string
}

const OutlinedText: FC<PropsWithChildren<OutlinedTextProps>> = ({
  children,

  text,
  className,
  ...rest
}) => {
  return (
    <p
      data-text={text || children?.toString()}
      className={cn("outlined-text", className)}
      {...rest}
    >
      <div className="shadow">{children}</div>
      <span>{children}</span>
    </p>
  )
}

export default memo(OutlinedText)
